import {
  type MerchantGroupQueryParam,
  MerchantGroupQueryParamName,
} from "src/merchantgroups/objects/MerchantGroupQueryParam";
import {
  type MerchantQueryParam,
  MerchantQueryParamName,
} from "src/merchants/objects/MerchantQueryParam";
import {
  GetPathWithParams,
  type QueryParams,
} from "src/utilities/URLParamsUtils";

export const STORE_DETAIL_VIEW_PATH = "/st/:storeUUID";
export const EDIT_STORE_VIEW_PATH = "/st/:storeUUID/edit";
export const STORES_VIEW_PATH = "/st";

/**
 * @deprecated
 */
export function GetStoresViewPath(
  merchant?: MerchantQueryParam,
  merchantGroup?: MerchantGroupQueryParam,
) {
  const queryParams: QueryParams = {};

  // Get Merchant UUID.
  if (merchant) {
    if (typeof merchant === "string") {
      queryParams[MerchantQueryParamName] = merchant;
    } else {
      queryParams[MerchantQueryParamName] = merchant.merchantUUID;
    }
  }

  // Get Merchant Group UUID.
  if (merchantGroup) {
    if (typeof merchantGroup === "string") {
      queryParams[MerchantGroupQueryParamName] = merchantGroup;
    } else {
      queryParams[MerchantGroupQueryParamName] =
        merchantGroup.merchantGroupUUID;
    }
  }

  return GetPathWithParams(STORES_VIEW_PATH, queryParams);
}

export const CREATE_STORE_VIEW_PATH = "/st/create";
